export enum ListStatusFilters {
  Active = 'active', // unpaid
  Inactive = 'inactive', // unpaid
  Draft = 'draft',
  Pending = 'pending',
}
export enum StudentClassStatus {
  Enrolled = 'enrolled',
  Withdraw = 'withdraw',
  Suspended = 'suspended',
  Graduated = 'graduated',
}
